<template>
  <div ref="logoutContainer" class="logout mention-popper">
    <a-modal
      :visible="props.visible"
      :footer="null"
      :get-container="() => ($refs.logoutContainer as HTMLElement)"
      :centered="true"
      :closable="isStandardScreen"
      @cancel="cancel"
    >
      <template #closeIcon>
        <img class="icon-close" src="@assets/svgs/preload-icon-popper-close.svg" alt="" />
      </template>
      <div class="title-container">
        <div class="mention-title logout-title">{{ $t('owork_base.are_you_log_out_title') }}</div>
        <div class="exit-tip mention-txt center">{{ isStandardScreen ? $t('owork_base.are_you_log_out') : '' }}</div>
      </div>
      <div class="exit-buts btn-box">
        <a-button
          class="exit-button button confirm-button"
          :type="isStandardScreen ? 'primary' : 'link'"
          @click="logout"
          >{{ $t('owork_base.log_out') }}</a-button
        >
        <a-divider
          v-if="!isStandardScreen"
          type="vertical"
          style="height: 20px; background-color: rgba(0, 0, 0, 0.12)"
        />
        <a-button v-if="!isStandardScreen" type="link" class="button color-btn" @click="cancel">{{
          $t('owork_base.cancel')
        }}</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script lang="ts">
  const CANCEL = 'cancel'
</script>

<script lang="ts" setup>
  import LoginManager from '@/core/LoginManager'
  import { getLoginPageUrl } from '@/BuildConfig'
  import { useSharedScreen } from '@/core/compositions/Screen'

  const { isStandardScreen } = useSharedScreen()
  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits([CANCEL])

  const cancel = () => {
    emit(CANCEL)
  }

  const logout = () => {
    const loginManager = LoginManager.getInstance()

    loginManager.logout(getLoginPageUrl())
  }
</script>

<style lang="stylus" scoped>

  .logout
    :deep(.ant-modal)
      width lighter_modal_width
    :deep(.ant-modal-body)
      rect(100%, 214px)
      padding 0px
      display inline-block
      text-align center
    .exit-tip
      font-weight bolder_font_weight
      font-size 20px
      line-height 26px
      rect(100%, 21px)
      margin-top 64px
      color default_color

    .exit-buts
      margin-top 43px
      width 100%
      display flex
      justify-content center
      .exit-button
        rect(88px, 36px)
        background #e32e27
        border-radius 8px
        border none
        font-weight bolder_font_weight
        &:hover
          background linear-gradient(0deg, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)), #e32e27
        &:active
          background linear-gradient(0deg, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)), #e32e27
    .icon-close
      icon-popper-close()

  @import '../styles/h5Adaptive/ConfirmDialog.styl'
</style>
